import React from 'react'
import fastFood from '../../assets/fastfood.svg'
import Footer from '../../components/Footer/Footer'
import styles from './NewDeliveries.module.css'
import { Link } from 'react-router-dom'

const NewDeliveries = () => {
    const arr = [1, 2, 3, 4]
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header>
                <h1>New Deliveries</h1>
                <p>Delivered</p>
            </header>
            <main>
                <p className={styles.status}>3 Active Deliveries</p>
                {
                    arr.map(item => (
                        <Link to="/delivery-info">
                            <div className={styles.card}>
                                <div className={styles.top}>
                                    <div className={styles.name}>
                                        <img src={fastFood} alt="fast-food" />
                                        <div className={styles.nameText}>
                                            <h3>Courier</h3>
                                            <small>Economy Delivery</small>
                                        </div>
                                    </div>
                                    <div className={styles.btnContainer}>
                                        <button><i className="far fa-times-circle"></i></button>
                                        <button>Accept</button>
                                    </div>
                                </div>
                                <div className={styles.middle}>
                                    <div className={styles.mode}>
                                        <small>Payment mode</small>
                                        <p>Cash on Pickup</p>
                                    </div>
                                    <div className={styles.payment}>
                                        <small>Payment</small>
                                        <p>$ 8.50</p>
                                    </div>
                                </div>
                                <div className={styles.bottom}>
                                    <p>28 Mott Street</p>
                                    <div className={styles.locationIcons}>
                                        <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                                        <span>......</span>
                                        <i className={styles.icon + " fas fa-location-arrow"}></i>
                                    </div>
                                    <p>St. Merry Church</p>
                                </div>
                            </div>
                        </Link>
                    ))
                }
            </main>
            <Footer />
        </div>
    )
}

export default NewDeliveries
